import React from 'react';

import errorMonkeyEmoji from '@pkg/assets/images/error-monkey.png';
import { Button } from '@pkg/components';

import { StepContent, Text, Title } from '../YatMintFlow.style';

import { EmojiImage, StepContentWrapper, StepWrapper } from './MintingSteps.style';

export function MintError({ onRetry }: { onRetry: () => void }) {
    return (
        <StepContent>
            <StepWrapper>
                <StepContentWrapper>
                    <EmojiImage src={errorMonkeyEmoji} alt={'Monkey covering its eyes emoji '} />
                    <Title>Whoops, something went wrong!</Title>
                    <Text>
                        There was an issue that prevented your Yat from being minted. It could be due to several reasons
                        such as gas fees changing or a glitch in the network.
                    </Text>
                </StepContentWrapper>
                <Button onClick={onRetry}>Try again</Button>
            </StepWrapper>
        </StepContent>
    );
}
